export default __webpack_public_path__ + "static/media/favicon.8d0a4159.ico";